import { Container } from '@/ui/design-system/Container'
import { ProBadge } from '../ProBadge'

const KIT_ITEMS = [
  {
    title: 'Dispersed campsite finder',
    body: 'Surface pull-offs and dead-end spurs near your route when your first choice is taken.',
    pro: true,
  },
  {
    title: 'Camp-smart weather',
    body: 'Overnight lows, wind, and rain windows for every stop — not a city forecast.',
    pro: true,
    partner: { label: 'via Campspotter', logoSrc: '/campspotter.png' },
  },
  {
    title: 'Shared trip gallery',
    body: "Everyone's shots in one gallery. Like, comment, and pick the trip cover together.",
  },
  {
    title: 'Mobile app',
    body: 'A push the second an invite lands or the first rig reaches camp.',
    comingSoon: true,
  },
]

export function FeaturesStrip() {
  return (
    <section className="bg-landing-base py-16 lg:py-24">
      <Container size="app">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,320px)_1fr] lg:gap-16">
          <div>
            <h2 className="text-2xl font-bold tracking-tight text-white sm:text-3xl" style={{ textWrap: 'balance' }}>
              Also in the kit
            </h2>
            <p className="mt-3 text-base leading-relaxed text-white/60">
              The rest of the workspace rides along with every trip — no extra setup.
            </p>
          </div>

          <ul className="grid gap-x-10 sm:grid-cols-2">
            {KIT_ITEMS.map((item) => (
              <li key={item.title} className="border-t border-landing-line py-5">
                <span className="flex flex-wrap items-center gap-2">
                  <span className="text-[15px] font-semibold text-white">{item.title}</span>
                  {item.pro && <ProBadge />}
                  {item.partner && (
                    <span className="inline-flex items-center gap-1 rounded-full bg-sky-400/10 px-2 py-0.5 text-[10px] font-medium text-sky-300">
                      <img src={item.partner.logoSrc} alt="" className="h-3 w-3 rounded-sm" />
                      {item.partner.label}
                    </span>
                  )}
                  {item.comingSoon && (
                    <span className="rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-medium text-white/60">
                      Coming soon
                    </span>
                  )}
                </span>
                <span className="mt-1 block text-sm leading-relaxed text-white/55">{item.body}</span>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </section>
  )
}
